import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareVisaBook', request)
}

export {post}
